import { get, post, put, del } from '@/utils/request';

const url = 'integral-activity-targets';

// 获取积分活动目标列表
export function index(data) {
  return get({
    url,
    data,
  });
}

// 获取实物奖励领取列表
export function getEntityReceiveList(id, data) {
  return get({
    url: `${url}/${id}/entity-students`,
    data,
  });
}

// 获取某个积分活动目标详情
export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

// 添加一个积分活动目标
export function store(data) {
  return post({
    url,
    data,
  });
}

// 获取实物奖励领取列表
export function receiveEntity(id, data) {
  return post({
    url: `${url}/${id}/entity-students`,
    data,
  });
}

// 删除某个积分活动目标
export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

// 恢复某个积分活动
export function restore(id, update_time) {
  return post({
    url: `${url}/${id}`,
    data: { update_time },
  });
}

// 删除某个积分活动目标
export function destroy(id, update_time) {
  return del({
    url: `${url}/${id}`,
    data: { update_time },
  });
}

// 学员取消领取实物奖励
export function cancelReceiveEntity(id, del_time) {
  return del({
    url: `${url}/${id}/entity-students`,
    data: { del_time },
  });
}
